export const config = {
  id: 'fullstack',
  icon: 'Code',
  color: 'purple',
  title: 'Fullstack Developer',
  description: 'Full-stack web development covering frontend, backend, and database technologies',
  department: 'Engineering',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 8,
    mid: 6,
    senior: 4
  }
};
